export const DOCUMENTATION_WIDTH = 800;
